// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardConfiguration_wrapper__YhHoL"};